import { useUIDSeed } from "react-uid";
import styled from "@emotion/styled";
import PropTypes from "prop-types";

import { useDrawerState } from "@hmn/coolinarika-web-core/context/Drawer";
import { InfiniteLoadTrigger, useListElastic } from "@hmn/coolinarika-web-core/hooks";

import { withErrorBoundary } from "../../ErrorBoundary";
import DishListing from "../Listing/Listing.component";
import { DishListingElement } from "../ListingElement";
import styles from "./Drawer.style";

const DishDrawerStyled = styled.div((props) => ({ ...styles(props) }));

const DishDrawerSingle = ({ className, ...props }) => {
    const uid = useUIDSeed();

    const {
        contentId,
        slug: stickyDishSlug,
        stickyDish,
        title: stickyDishTitle,
    } = useDrawerState();

    const { pages, ref } = useListElastic({
        resource: "jela/2nd-level",
        id: contentId,
        enabled: !!contentId,
    });

    return (
        <DishDrawerStyled className={className} {...props}>
            <DishListing className="dishDrawerListing">
                {stickyDish && (
                    <DishListingElement
                        imageId={stickyDish?.imageId}
                        title={`${stickyDishTitle} - pogledaj sve recepte`}
                        href={`/jela/${stickyDishSlug}`}
                        showIcon={false}
                    />
                )}

                {pages?.map((foodTypePage, pageIndex) =>
                    foodTypePage?.map((item, index) => (
                        <DishListingElement
                            key={uid(item?.id || `${pageIndex}-${index}`)}
                            imageId={item?.image?.id}
                            title={item?.title}
                            href={`/jela/${item?.parent?.slug}/${item?.slug}`}
                            showIcon={false}
                        />
                    )),
                )}
            </DishListing>
            <InfiniteLoadTrigger ref={ref} />
        </DishDrawerStyled>
    );
};

DishDrawerSingle.propTypes = {
    className: PropTypes.string,
};

DishDrawerSingle.defaultProps = {
    className: undefined,
};

export default withErrorBoundary(DishDrawerSingle);
